
const user = {
  state: {
    userInfo: {
      name: '',
      userId: '',
      email: '',
      status: '',
    },
    withdrawAccount: '',
    depositAccount: '',
    noticeDialogShow: false,
  },

  mutations: {
    setUserInfo(state,userInfo){
        state.userInfo = userInfo;
    },
  },

  actions: {
  },
  getters:{
    userInfo: state => state.userInfo,
  }
};

export default user;
